import { z } from "zod";

import { Currency } from "hakikat/utils";

export enum PaymentMethod {
  CASH = 'cash',
  CARD = 'card',
  PAYPAL = 'paypal',
  TRANSFER = 'transfer'
};

export enum PaymentStatus {
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  DECLINED = 'declined',
  WAITING = 'waiting'
};

export type Payment = z.infer<typeof PaymentSchema>;
export const PaymentSchema = z.object({
  id: z.string(),
  uid: z.string(),
  oid: z.string(),

  tid: z.string().optional(),
  hash: z.string().optional(),

  amount: z.number().positive("Price must be positive.").min(0.01, "Price must be at least 0.01."),
  currency: z.nativeEnum(Currency),

  method: z.nativeEnum(PaymentMethod),
  status: z.nativeEnum(PaymentStatus),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date()
});

export type PaymentCreateResponse = z.infer<typeof PaymentCreateResponseSchema>;
export const PaymentCreateResponseSchema = z.object({
  id: z.string(),
  tid: z.string().optional(),
  hash: z.string().optional(),
  method: z.nativeEnum(PaymentMethod)
});
